import { render, staticRenderFns } from "./change-password-dialog.vue?vue&type=template&id=4a57ba14&"
import script from "./change-password-dialog.vue?vue&type=script&lang=js&"
export * from "./change-password-dialog.vue?vue&type=script&lang=js&"
import style0 from "./change-password-dialog.vue?vue&type=style&index=0&id=4a57ba14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports